import { gql } from '@apollo/client'

export const WebhookSubscriptionDetailsFragment = gql`
  fragment WebhookSubscriptionDetails on WebhookSubscriptionDto {
    id
    customerId
    callbackUrl
    eventTypes
    isEnabled
    createdAt
    createdBy
    lastModifiedAt
    lastModifiedBy
    lastDeliveryStatus
    lastDeliveryAttemptAt
    lastDeliveryStatusCode
    lastDeliveryError
  }
`
